import { Operation } from "../.."
import { TableName } from "../../../../tables"
import { Link } from "../../../../features/ui"
import { RoutePath, useRoutesHooks } from "../../../../features/routes"
import { useMemo } from "react"
import { useDescribeHooks } from "../../../../features/data-types"

type Props = {
    table: TableName
    operation: Operation
}

export const OperationLink = (props: Props) => {
    const { table, operation } = props

    const { describe } = useDescribeHooks()
    const { getRoutePath } = useRoutesHooks()

    const icon = useMemo(() => new Map<TableName, string>()
        .set(TableName.PURCHASE_ORDERS, 'cart3')
        .set(TableName.SALE_ORDERS, 'tags')
        .set(TableName.HOARD_ORDERS, 'layers')
        .get(table) || 'box-arrow-right'
    , [table])

    const routePath = useMemo(() => {
        const routePaths = new Map<TableName, RoutePath>()
            .set(TableName.PURCHASE_ORDERS, RoutePath.PURCHASES)
            .set(TableName.SALE_ORDERS, RoutePath.SALES)
            .set(TableName.HOARD_ORDERS, RoutePath.HOARDS)
        return getRoutePath(routePaths.get(table)!, operation.id)
    }, [table, operation.id])

    return (
        <Link
            text={describe(table, operation!)}
            icon={icon}
            kind="primary"
            to={routePath}
        />
    )
}
